var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.a9dc26a008fe1538450500f75ada6a0e.svg#c';
                    var viewUrl = 'sprites.a9dc26a008fe1538450500f75ada6a0e.svg#view-c';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 17 10',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };